import { _SERVICE as ICRC21Service, idlFactory as idl } from '@idls/icrc21/icrc21.did'
import { config } from '@plug-core/appConfig'
import { createActor } from '@plug-core/utils/createActor'

export const fetchCanisterConsentMessage = async (
  canisterId: string,
  method: string,
  arg: ArrayBuffer
) => {
  const agent = config.getAgent()
  const actor = createActor<ICRC21Service>(idl, {
    canisterId,
    agent,
  })

  const concent = await actor.icrc21_canister_call_consent_message({
    arg: new Uint8Array(arg),
    method,
    user_preferences: {
      metadata: {
        language: 'en',
      },
      device_spec: [],
    },
  })

  if ('Ok' in concent) {
    if ('GenericDisplayMessage' in concent.Ok.consent_message) {
      return concent.Ok.consent_message.GenericDisplayMessage
    } else {
      return Promise.reject('Missing message')
    }
  }

  return Promise.reject('Missing message')
}
